export default "__VITE_ASSET__pDs_uhsD__"